import React from 'react';
import { AlertCircle, CheckCircle, X } from 'lucide-react';

/**
 * Notification component for displaying success, error, or info messages
 *
 * @param {Object} props
 * @param {Object} props.notification - Notification data
 * @param {boolean} props.notification.show - Whether to show the notification
 * @param {string} props.notification.message - The notification message
 * @param {string} props.notification.type - Type of notification ('success', 'error', or 'info')
 * @param {Function} props.onDismiss - Function to call when dismissing the notification
 */
const Notification = ({ notification, onDismiss }) => {
    if (!notification.show) return null;

    return (
        <div
            className={`font-[poppins] fixed bottom-4 right-4 max-w-md px-4 py-3 rounded-lg shadow-lg flex items-center ${
                notification.type === "success" ? "bg-green-100 text-green-800 border-l-4 border-green-500" :
                notification.type === "error" ? "bg-red-100 text-red-800 border-l-4 border-red-500" :
                "bg-blue-100 text-blue-800 border-l-4 border-blue-500"
            }`}>
            {notification.type === "success" ?
                <CheckCircle className="w-5 h-5 mr-3"/> :
                <AlertCircle className="w-5 h-5 mr-3"/>
            }
            <span>{notification.message}</span>
            <button
                onClick={onDismiss}
                className="ml-4 text-gray-500 hover:text-gray-700"
            >
                <X className="w-4 h-4"/>
            </button>
        </div>
    );
};

export default Notification;